module.exports = __webpack_public_path__ + "assets/valance-wave-scallop.007cea4d.svg";